import { Component, OnInit, ViewEncapsulation, Input, AfterViewInit } from "@angular/core";
import { TherapieTabsEnum } from '../titration-rechner.model';
import { PartnerNamesEnum } from "../../medizinisches-cannabisantrag";


@Component({
    selector: 'app-titration-rechner-info',
    templateUrl: "./titration-rechner-info.component.html",
    styleUrls: ["./titration-rechner-info.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class TitrationRechnerInfoComponent implements OnInit, AfterViewInit {
    @Input() partnerName: any = "";
    @Input() accNumber: number;
    @Input() ActiveTherapieTab: TherapieTabsEnum;
    @Input() isPrivatePage: boolean;

    PartnerNamesEnum = PartnerNamesEnum;
    TherapieTabsEnum = TherapieTabsEnum;
    expendList: any[] = [];

    PATDronabinolList: any[] = [];
    PATCannabisextrakteList: any[] = [];

    get InfoFirstLineText() {
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                return "Hormosan Cannabisextrakts";
            default:
                return "Cannabisarzneimittels";
        }
    }

    get CannabisTHCText() {
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                return "das Cannabisarzneimittels";
            default:
                return "die THC Konzentration das";
        }
    }

    get ProductTHCText() {
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                return "Produktauswahl";
            default:
                return "THC Konzentration";
        }
    }

    get OptimaleDosierungClass() {
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
                return "bg-light-pink";
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                return "bg-light-green";
            default:
                return "bg-light-blue";
        }
    }

    constructor() {

    }

    setTableData() {
        this.PATDronabinolList= [
            { zieldosis: '5 mg THC/Tag', bedarf: '(ca. 150 mg/Monat)', thcKonz: '10 mg/mL', flasch: '20 mL', versch: '200 mg', className: 'td-green' },
            { zieldosis: '7,5 mg THC/Tag', bedarf: '(ca. 225 mg/Monat)', thcKonz: '10 mg/mL', flasch: '30 mL', versch: '300 mg', className: 'td-green' },
            { zieldosis: '10 mg THC/Tag', bedarf: '(ca. 300 mg/Monat)', thcKonz: '10 mg/mL', flasch: '40 mL', versch: '400 mg', className: 'td-green' },
            { zieldosis: '15 mg THC/Tag', bedarf: '(ca. 450 mg/Monat)', thcKonz: '25 mg/mL', flasch: '20 mL', versch: '500 mg', className: 'td-green' },
            { zieldosis: '20 mg THC/Tag', bedarf: '(ca. 600 mg/Monat)', thcKonz: '25 mg/mL', flasch: '30 mL', versch: '750 mg', className: 'td-green' },
            { zieldosis: '25 mg THC/Tag', bedarf: '(ca. 750 mg/Monat)', thcKonz: '25 mg/mL', flasch: '35 mL', versch: '875 mg', className: 'td-yellow' },
            { zieldosis: '30 mg THC/Tag', bedarf: '(ca. 900 mg/Monat)', thcKonz: '25 mg/mL', flasch: '40 mL', versch: '1.000 mg', className: 'td-yellow' },
            { zieldosis: '40 mg THC/Tag', bedarf: '(ca. 1.200 mg/Monat)', thcKonz: '25 mg/mL', flasch: '50 mL', versch: '1.250 mg', className: 'td-pink' },
            { zieldosis: '50 mg THC/Tag', bedarf: '(ca. 1.500 mg/Monat)', thcKonz: '50 mg/mL', flasch: '35 mL', versch: '1.750 mg', className: 'td-pink' }
        ];
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                this.PATCannabisextrakteList = [
                    {
                        thcKonz: { label: '5 mg THC/mL', value: '(bspw. 5/20)' },
                        fiveMg: { label: '30 mL', value: '(150 mg THC)', className: 'td-green' },
                        tenMg: { label: '65 mL', value: '(325 mg THC)', className: 'td-yellow' },
                        twentyMg: { label: '130 mL', value: '(325 mg THC)', className: 'td-pink' },
                        thirtyMg: null,
                        fourtyMg: null,
                        fiftyMg: null
                    },
                    {
                        thcKonz: { label: '10 mg THC/mL', value: '(bspw. 10/10)' },
                        fiveMg: { label: '20 mL', value: '(200 mg THC)', className: 'td-green' },
                        tenMg: { label: '30 mL', value: '(300 mg THC)', className: 'td-green' },
                        twentyMg: { label: '64 mL', value: '(640 mg THC)', className: 'td-yellow' },
                        thirtyMg: { label: '100 mL', value: '(1.000 mg THC)', className: 'td-pink' },
                        fourtyMg: null,
                        fiftyMg: null
                    },
                    {
                        thcKonz: { label: '20 mg THC/mL', value: '(bspw. 20/6)' },
                        fiveMg: { label: '10 mL', value: '(200 mg THC)', className: 'td-green' },
                        tenMg: { label: '16 mL', value: '(320 mg THC)', className: 'td-green' },
                        twentyMg: { label: '30 mL', value: '(600 mg THC)', className: 'td-green' },
                        thirtyMg: { label: '50 mL', value: '(1.000 mg THC)', className: 'td-yellow' },
                        fourtyMg: { label: '64 mL', value: '(1.280 mg THC)', className: 'td-yellow' },
                        fiftyMg: { label: '80 mL', value: '(1.600 mg THC)', className: 'td-pink' },
                    },
                    {
                        thcKonz: { label: '25 mg THC/mL', value: '(bspw. 25/0, 25/25)' },
                        fiveMg: null,
                        tenMg: { label: '13 mL', value: '(325 mg THC)', className: 'td-green' },
                        twentyMg: { label: '25 mL', value: '(625 mg THC)', className: 'td-green' },
                        thirtyMg: { label: '40 mL', value: '(1.000 mg THC)', className: 'td-green' },
                        fourtyMg: { label: '50 mL', value: '(1.250 mg THC)', className: 'td-yellow' },
                        fiftyMg: { label: '64 mL', value: '(1.600 mg THC)', className: 'td-yellow' },
                    }
                ];
                break;
            default:
                this.PATCannabisextrakteList= [
                    {
                        thcKonz: { label: '5 mg THC/mL', value: '(bspw. 5/20)' },
                        fiveMg: { label: '30 mL', value: '(150 mg THC)', className: 'td-green' },
                        tenMg: { label: '65 mL', value: '(325 mg THC)', className: 'td-yellow' },
                        twentyMg: { label: '130 mL', value: '(325 mg THC)', className: 'td-pink' },
                        thirtyMg: null,
                        fourtyMg: null,
                        fiftyMg: null
                    },
                    {
                        thcKonz: { label: '10 mg THC/mL', value: '(bspw. 10/10)' },
                        fiveMg: { label: '20 mL', value: '(200 mg THC)', className: 'td-green' },
                        tenMg: { label: '30 mL', value: '(300 mg THC)', className: 'td-green' },
                        twentyMg: { label: '64 mL', value: '(640 mg THC)', className: 'td-yellow' },
                        thirtyMg: { label: '100 mL', value: '(1.000 mg THC)', className: 'td-pink' },
                        fourtyMg: null,
                        fiftyMg: null
                    },
                    {
                        thcKonz: { label: '12,5 mg THC/mL', value: '(bspw. 12,5/12,5)' },
                        fiveMg: { label: '16 mL', value: '(200 mg THC)', className: 'td-green' },
                        tenMg: { label: '25 mL', value: '(313 mg THC)', className: 'td-green' },
                        twentyMg: { label: '50 mL', value: '(625 mg THC)', className: 'td-yellow' },
                        thirtyMg: { label: '80 mL', value: '(1.000 mg THC)', className: 'td-pink' },
                        fourtyMg: { label: '100 mL', value: '(1.250 mg THC)', className: 'td-pink' },
                        fiftyMg: null
                    },
                    {
                        thcKonz: { label: '20 mg THC/mL', value: '(bspw. 20/20)' },
                        fiveMg: { label: '10 mL', value: '(200 mg THC)', className: 'td-green' },
                        tenMg: { label: '16 mL', value: '(320 mg THC)', className: 'td-green' },
                        twentyMg: { label: '30 mL', value: '(600 mg THC)', className: 'td-green' },
                        thirtyMg: { label: '50 mL', value: '(1.000 mg THC)', className: 'td-yellow' },
                        fourtyMg: { label: '64 mL', value: '(1.280 mg THC)', className: 'td-yellow' },
                        fiftyMg: { label: '80 mL', value: '(1.600 mg THC)', className: 'td-pink' },
                    },
                    {
                        thcKonz: { label: '25 mg THC/mL', value: '(bspw. 25/0)' },
                        fiveMg: null,
                        tenMg: { label: '13 mL', value: '(325 mg THC)', className: 'td-green' },
                        twentyMg: { label: '25 mL', value: '(625 mg THC)', className: 'td-green' },
                        thirtyMg: { label: '40 mL', value: '(1.000 mg THC)', className: 'td-green' },
                        fourtyMg: { label: '50 mL', value: '(1.250 mg THC)', className: 'td-yellow' },
                        fiftyMg: { label: '64 mL', value: '(1.600 mg THC)', className: 'td-yellow' },
                    },
                    {
                        thcKonz: { label: '50 mg THC/mL', value: '(bspw. 50/0)' },
                        fiveMg: null,
                        tenMg: null,
                        twentyMg: { label: '13 mL', value: '(650 mg THC)', className: 'td-green' },
                        thirtyMg: { label: '20 mL', value: '(1.000 mg THC)', className: 'td-green' },
                        fourtyMg: { label: '25 mL', value: '(1.250 mg THC)', className: 'td-green' },
                        fiftyMg: { label: '30 mL', value: '(1.500 mg THC)', className: 'td-green' },
                    }
                ];
                break;
        }
    }

    ngOnInit(): void {
        this.setTableData();
        this.expendList.push(this.accNumber);
    }

    ngAfterViewInit() {
        this.navigateToBlockId(this.accNumber);
        setTimeout(() => {
            this.navigateToBlockId(this.accNumber);
        }, 100);
    }

    navigateToBlockId(blockId) {
        const elmId = `titration_plan_${blockId}_info`;
        const elm: HTMLElement = document.getElementById(elmId) as HTMLElement;
        if (elm) {
            elm.scrollIntoView({ behavior: "smooth" });
        }
    }

    hasActiveClass(num) {
        return this.expendList.indexOf(num) > -1;
    }

    fnToggleExpend(num: any) {
        let ind = this.expendList.indexOf(num);
        if (ind > -1) {
            this.expendList.splice(ind, 1);
        } else {
            this.expendList.push(num);
        }
    }
}
